module.exports = __webpack_public_path__ + "static/icon_cfdj-f1e9ef45a8db2a244deb46538d215567.png";